import _get from 'lodash/get';

import { objectToCamelCase } from '../libs/format';

export function selectReviews(state) {
  return objectToCamelCase(_get(state, 'business.reviews.value', []));
}
